import { logoutFactory } from '../../shared/reducers/user';
import { finaliseLogout } from '../../shared/store/thunks';
import appConfig from '../helpers/appConfig';
import type { ThunkAPI } from '../store/types';
import { extensionUnregistering } from './extension';

export const logout = logoutFactory<ThunkAPI>((thunkAPI) => {
  const { extension } = appConfig;

  thunkAPI.dispatch(extensionUnregistering());

  if (!extension) {
    console.debug('user.js - !extension');
    thunkAPI.dispatch(finaliseLogout());
    return;
  }

  extension.isActive = false;

  extension.once('unregistered', () => {
    console.debug('user.js - extensionOnceUnregistered');
    thunkAPI.dispatch(finaliseLogout());
  });

  extension.clearSubscriptions();
  extension.stop();
});
